function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { withTheme } from 'styled-components';
import { Link } from 'react-router-dom';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { timeSince } from '@finect/front-utils/timeSince';
import { isProfileAdviser } from '@finect/front-core/Profiles';
import { getReviewPath } from '../utils';
import { Author } from '../../Author';
import { Stars } from './../../Stars';
import { Toolbar } from './Toolbar/Toolbar';
import { postlike, deleteLike } from './actions';
import { Inner, Header, PublishDate, ProfessionalBadge, Footer, Entry, Meta, Body, Excerpt, Title } from './partials';
export var ReviewCardItemList = function (_React$Component) {
  _inherits(ReviewCardItemList, _React$Component);
  var _super = _createSuper(ReviewCardItemList);
  function ReviewCardItemList() {
    var _this;
    _classCallCheck(this, ReviewCardItemList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      features: [],
      liked: false,
      likes: _this.props.review.socialStats.likes,
      editing: false,
      deleted: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleCommentClick", function () {
      var _getReviewPath = getReviewPath(_this.props.theme, _this.props.product, _this.props.review, _this.props.tag),
        superPartnerURL = _getReviewPath.superPartnerURL;
      window.location.href = superPartnerURL;
    });
    _defineProperty(_assertThisInitialized(_this), "handleLike", function () {
      _this.state.liked ? _this.fetchUnlike() : _this.fetchLike();
      _this.setState({
        liked: !_this.state.liked,
        likes: !_this.state.liked ? _this.state.likes + 1 : _this.state.likes - 1
      });
    });
    return _this;
  }
  _createClass(ReviewCardItemList, [{
    key: "fetchIsLiked",
    value: function fetchIsLiked() {
      var _this2 = this;
      var me = this.props.me;
      if (me && me.isLoggedIn) {
        finectAPI({
          version: 'v4',
          path: "users/me/likes/reviews/".concat(this.props.review.id),
          method: 'GET',
          onSuccess: function onSuccess(_ref) {
            var data = _ref.data;
            _this2.setState({
              liked: data.me === 'like'
            });
          }
        });
      }
      this.setState({
        liked: false
      });
    }
  }, {
    key: "fetchLike",
    value: function fetchLike() {
      postlike(this.props.review.id);
    }
  }, {
    key: "fetchUnlike",
    value: function fetchUnlike() {
      deleteLike(this.props.review.id);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchIsLiked();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        me = _this$props.me,
        _this$props$withEntit = _this$props.withEntityCard,
        withEntityCard = _this$props$withEntit === void 0 ? false : _this$props$withEntit,
        finectApp = _this$props.finectApp,
        theme = _this$props.theme,
        product = _this$props.product,
        review = _this$props.review;
      var liked = this.state.liked;
      var isOwn = me && me.id === review.author.id;
      var path = getReviewPath(theme, product, review, this.props.tag);
      var isAdviser = isProfileAdviser(review.author);
      var titleLinkProps = ['front-products'].includes(finectApp) && path.pattern.match ? {
        to: path.path,
        as: Link
      } : {
        href: path.superPartnerURL
      };
      return React.createElement(Inner, null, isAdviser ? React.createElement(ProfessionalBadge, {
        pro: isAdviser
      }, "Review profesional") : '', React.createElement(Entry, {
        isAdviser: isAdviser
      }, React.createElement(Header, null, React.createElement(Author, {
        withEntityCard: withEntityCard,
        main: false,
        author: this.props.review.author,
        isUser: true,
        loggedIn: true,
        withMeta: true
      })), React.createElement(Meta, null, React.createElement(Stars, {
        value: this.props.review.score
      }), React.createElement(PublishDate, null, "Publicado ", timeSince(new Date(review.revision.created)))), React.createElement(Body, null, React.createElement(Title, _extends({
        "data-fi-event": "review-title"
      }, titleLinkProps, {
        rel: "nofollow"
      }), this.props.review.title), React.createElement(Excerpt, null, review.body.text.substring(0, 210), " ...")), React.createElement(Footer, null, React.createElement(Toolbar, {
        like: {
          qty: this.state.likes,
          action: this.handleLike,
          done: liked,
          disable: isOwn ? 'No puedes realizar esta acción sobre tu propia opinión' : ''
        },
        respond: {
          qty: this.props.review.comments.length,
          path: path.superPartnerURL,
          action: this.handleCommentClick
        },
        share: {
          title: this.props.review.title,
          path: path.path
        }
      }))));
    }
  }]);
  return ReviewCardItemList;
}(React.Component);
export default React.memo(withTheme(ReviewCardItemList));